import styled from '@emotion/styled'

const Divider = styled.hr`
  border-width: 0;
  border-top: 1px solid ${props => props.theme.colors.hairline};
`

export default Divider
